module.exports = __webpack_public_path__ + "img/icon_noticebell.75684c61.png";